import { render, staticRenderFns } from "./CoreanosForm.vue?vue&type=template&id=51797ccd&scoped=true"
import script from "./CoreanosForm.vue?vue&type=script&lang=js"
export * from "./CoreanosForm.vue?vue&type=script&lang=js"
import style0 from "./CoreanosForm.vue?vue&type=style&index=0&id=51797ccd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51797ccd",
  null
  
)

export default component.exports